//Must contain a number in every list item
const isNumericList = (list: any[]) =>
    list.every(item => /\d+/.test(item.text));

export const sortNumericAnswers = (questions: any[]) => {
    return questions.map(question => {
        if (question.answerList && isNumericList(question.answerList)) {
            return {
                ...question,
                answerList: [...question.answerList].sort(
                    (a, b) => Number(a.text) - Number(b.text)
                )
            };
        }
        return question;
    });
}